module.exports = __webpack_public_path__ + "img/7_198.b59202b9.png";